import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

export const renderIcon = (label, value) => {
  switch (label) {
    case "Trend":
      return value === "Increasing" ? (
        <ArrowUpwardIcon color="success" />
      ) : value === "Stable" ? (
        <HorizontalRuleIcon />
      ) : (
        <ArrowDownwardIcon color="error" />
      );
    case "Status":
      return value === "In Use" ? (
        <CheckCircleIcon color="success" />
      ) : (
        <CancelIcon color="error" />
      );
    case "Anomalies":
      return value === "None" ? '' : <WarningAmberIcon color="warning" />;
    default:
      return null;
  }
};
